/*
 *		Copyright (c) 2011-2017 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accNodeExpirationDate', ['template', 'Settings', 'DateTools', '$timeout', '$filter', function (template, Settings, DateTools, $timeout, $filter) {
        return {
            scope: {
                node: '=accNodeExpirationDate'
            },
            templateUrl: template('nodes/_calendar_input'),
            controller: ['$scope', function ($scope) {
                $scope.$watch('node_expiration.date', function (value) {
                    if (value) {
                        $scope.node_expiration.enabled = true;
                        $scope.node_expiration.setDate();
                    }
                });

                $scope.canHaveInfiniteExpiration = function () {
                    return !Settings['shared_folder_expiration_required'];
                };

                $scope.toggleInfiniteExpiration = function () {
                    if ($scope.node_expiration.enabled) {
                        $scope.node_expiration.setDate();
                    } else {
                        $scope.node_expiration.setInfinite();
                    }
                };
            }],
            link: function ($scope) {
                $scope.node_expiration = {
                    setInfinite: function () {
                        $scope.node['expiration_date'] = null;
                    },
                    setDate: function () {
                        if (this.date) {
                            $scope.node['expiration_date'] = $filter('date')(this.date, 'yyyy-MM-dd');
                        } else {
                            $scope.node['expiration_date'] = undefined;
                        }
                    }
                };

                $scope.dateOptions = {
                    showWeeks: false,
                    startingDay: 1
                };

                $scope.minDate = new Date();

                var emptyState = Settings['shared_folder_expiration_required'] ? undefined : '';

                $scope.node['expiration_date'] = $scope.node['expiration_date'] || emptyState;

                _updateNodeExpiration($scope);

                if (Settings['shared_folder_expiration_required'] && Settings['shared_folder_expiration_max_days'] !== '') {
                    $scope.maxDate = DateTools.addDays($scope.minDate, Settings['shared_folder_expiration_max_days']);
                }
            }
        };

        function _updateNodeExpiration($scope) {
            $scope.node_expiration.enabled = Settings['shared_folder_expiration_required'] || !!$scope.node['expiration_date'];
            $scope.node_expiration.date = $scope.node['expiration_date'];
        }
    }]);
